import { useEffect, useMemo, useState } from "react";
import { http } from "../../lib/api";
import SearchableSelect from "../SearchableSelect";

let cache = null;
// GİB vergi daireleri (1.046) — daire kodu, adı, il veya ilçe ile aranır; ↑↓ ile gezilir, Enter/Boşluk seçip yan kutuya geçer, Tab da seçip geçer
export default function TaxOfficeSelect({ value, onChange, testid }) {
  const [list, setList] = useState(cache || []);
  useEffect(() => { if (cache) return; http.get("/tax-offices").then((r) => { cache = r.data; setList(r.data); }).catch(() => {}); }, []);
  const options = useMemo(() => {
    const dup = new Set(list.map((o) => o.name).filter((n, i, a) => a.indexOf(n) !== i));   // aynı adlı daireler (Selçuk VD: İzmir/Aydın) il ile ayrışır
    const opts = list.map((o) => ({ value: dup.has(o.name) ? `${o.name} (${o.il})` : o.name, label: `${o.code} · ${o.name} — ${o.il}${o.ilce && o.ilce !== "Merkez" ? ` / ${o.ilce}` : ""}` }));
    return value && !opts.some((o) => o.value === value) ? [{ value, label: value }, ...opts] : opts;
  }, [list, value]);
  return <SearchableSelect options={options} value={value || ""} onChange={onChange} placeholder="Vergi dairesi kodu, adı veya il yazın…" testid={testid} />;
}
